import React from "react";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function CardPayment({ cardMountRef, cardReady, processing, error, onConfirm, labels }) {
  const mergedLabels = {
    title: labels?.title || "请输入信用卡信息",
    loading: labels?.loading || "正在加载支付组件...",
    confirm: labels?.confirm || "确认付款",
    processing: labels?.processing || "处理中...",
    hint: labels?.hint || "如需验证(3D Secure)，将自动弹出/跳转完成验证",
    unionpayHint:
      labels?.unionpayHint || "银联卡如未印刷有效期或安全码（CVC）, 可填写有效期12/30，CVC 000",
  };

  return (
    <MKBox mt={4}>
      <MKTypography variant="h6" fontWeight="bold">
        {mergedLabels.title}
      </MKTypography>

      <MKBox sx={{ width: "100%", maxWidth: 560, ml: 0, mr: "auto" }}>
        <MKBox
          mt={2}
          sx={{
            border: "1px solid rgba(0,0,0,0.15)",
            borderRadius: "8px",
            p: 1.25,
          }}
        >
          <div ref={cardMountRef} />
        </MKBox>

        <MKBox
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            mt: 1,
            p: 1.25,
            bgcolor: "rgba(229, 246, 253, 0.7)",
            borderRadius: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <MKTypography variant="body1" color="info" fontWeight="bold">
            ℹ️
          </MKTypography>
          <MKTypography variant="body2" color="info" fontWeight="bold" sx={{ lineHeight: 1.45 }}>
            {mergedLabels.unionpayHint}
          </MKTypography>
        </MKBox>

        {!cardReady && !error && (
          <MKTypography variant="caption" color="text" display="block" mt={1}>
            {mergedLabels.loading}
          </MKTypography>
        )}

        {error && (
          <MKTypography variant="caption" color="error" display="block" mt={1}>
            {error}
          </MKTypography>
        )}

        <MKBox mt={2}>
          <MKButton
            variant="contained"
            color="success"
            onClick={onConfirm}
            disabled={!cardReady || processing}
            fullWidth
          >
            {processing ? mergedLabels.processing : mergedLabels.confirm}
          </MKButton>
        </MKBox>

        <MKTypography variant="caption" color="text" display="block" mt={1}>
          {mergedLabels.hint}
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

CardPayment.propTypes = {
  cardMountRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })])
    .isRequired,
  cardReady: PropTypes.bool,
  processing: PropTypes.bool,
  error: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    title: PropTypes.string,
    loading: PropTypes.string,
    confirm: PropTypes.string,
    processing: PropTypes.string,
    hint: PropTypes.string,
    unionpayHint: PropTypes.string,
  }),
};

CardPayment.defaultProps = {
  cardReady: false,
  processing: false,
  error: "",
  labels: null,
};

export default CardPayment;
